import { render, staticRenderFns } from "./TemplateDatas.vue?vue&type=template&id=78fe4225&scoped=true"
import script from "./TemplateDatas.vue?vue&type=script&lang=js"
export * from "./TemplateDatas.vue?vue&type=script&lang=js"
import style0 from "./TemplateDatas.vue?vue&type=style&index=0&id=78fe4225&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fe4225",
  null
  
)

export default component.exports